import React from 'react';
import { Button } from '@mui/material';
import { ISidebarButton } from './interfaces';

export const SidebarButton: React.FC<ISidebarButton> = ({
  children,
  sx,
  onClick,
}): JSX.Element => {
  return (
    <Button
      onClick={onClick}
      sx={{
        width: '100%',
        ...sx,
      }}
    >
      {children}
    </Button>
  );
};
